import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useEffect, useState, memo, Suspense } from 'react'
import { useFilterButton } from '../../provider/FilterButtonProvider'

import CheckboxField from '../../components/form/CheckboxField'
import SelectField from '../../components/form/SelectField'
import Button from '../../components/ui/button'
import Index from '../../components/ui/popup'
import FiltersBlock from '../../components/index/FiltersBlock'
// import FiltersCalendar from '../../components/index/FiltersCalendare'

import { Form, Field, FieldProps, FormikProps, FormikValues } from 'formik'
import { indexGenders, materials } from '../../constants'

import { initialValuesTypes } from './indexDefaultComponent'

import isEqual from 'lodash/isEqual'
import './indexFilter.sass'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/rootReducer'
import PaginationLoader from '../../components/ui/paginationLoader/PaginationLoader'

const FiltersCalendar = React.lazy(() => import('../../components/index/FiltersCalendare'))

interface Props {
    showMoreFilters: boolean
    setShowMoreFilters: React.Dispatch<boolean>
    initialValues: initialValuesTypes
    initialValuesClone: initialValuesTypes
}

const IndexFilter: React.FunctionComponent<Props> = ({
    showMoreFilters,
    setShowMoreFilters,
    initialValues,
    initialValuesClone
}: Props) => {
    const [t] = useTranslation()

    const handleCheckbox = (form: FormikProps<FormikValues>) => {
        !showMoreFilters && form.handleSubmit()
    }

    const [buttonStyle, setButtonStyle] = useState('button')
    const isPageScrolled = useSelector<RootState, boolean>((state) => state.common.isPageScrolled)

    useEffect(() => {
        setButtonStyle(isEqual(initialValues, initialValuesClone) ? 'button' : 'button checked')
        // eslint-disable-next-line
    }, [initialValuesClone])

    const openPopup = () => {
        setShowMoreFilters(true)
    }

    useFilterButton(showMoreFilters, setShowMoreFilters)

    return (
        <div className="filter_index" id={'filterIndex'}>
            <Form>
                {showMoreFilters ? (
                    <>
                        <Index onClose={() => setShowMoreFilters(false)}>
                            <div className="filterContent_Index">
                                <div className="selects">
                                    <Field name="material">
                                        {({ field, form }: FieldProps) => (
                                            <SelectField
                                                form={form}
                                                field={field}
                                                label={t('Material')}
                                                options={materials}
                                            />
                                        )}
                                    </Field>

                                    <Field name="gender">
                                        {({ field, form }: FieldProps) => (
                                            <SelectField
                                                form={form}
                                                field={field}
                                                label={t('Gender')}
                                                options={indexGenders}
                                            />
                                        )}
                                    </Field>
                                    <div className={'checkbox_group_index'}>
                                        <p>{t(`Contributors`)}</p>
                                        <Field name="certified">
                                            {({ field, form }: FieldProps) => (
                                                <CheckboxField
                                                    form={form}
                                                    field={field}
                                                    label={t('Only Certified')}
                                                    onChangeCallback={handleCheckbox}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className={'checkbox_group_index'}>
                                        <p>{t(`Contributions`)}</p>
                                        <Field name="free">
                                            {({ field, form }: FieldProps) => (
                                                <CheckboxField
                                                    form={form}
                                                    field={field}
                                                    label={t('Only Free')}
                                                    onChangeCallback={handleCheckbox}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                </div>
                                <div className={'date_picker'}>
                                    <p style={{ marginBottom: '10px' }}>{t('Period')}</p>
                                    <Field>
                                        {({ form }: FieldProps) => (
                                            <Suspense fallback={<PaginationLoader />}>
                                                <FiltersCalendar form={form} />
                                            </Suspense>
                                        )}
                                    </Field>
                                </div>
                                <div className="buttonsGroup">
                                    <Button id={'key_submit'} label={t('Apply filters')} type="submit" />
                                    <Field>
                                        {({ form }: FieldProps) => (
                                            <p className={'clearFilters'} onClick={() => form.resetForm()}>
                                                {t('Clear filters')}
                                            </p>
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </Index>
                        <div className="checkboxes_index" style={{ marginTop: '20px' }} />
                    </>
                ) : (
                    <div className="checkboxes_index" style={{ marginTop: '20px' }}>
                        <Field>
                            {({ form }: FieldProps) => (
                                <FiltersBlock
                                    form={form}
                                    setShowMoreFilters={setShowMoreFilters}
                                    initialValues={initialValues}
                                    initialValuesClone={initialValuesClone}
                                />
                            )}
                        </Field>
                        {/*{!isPageScrolled && (*/}
                        <Button label={t('Filters')} onClick={openPopup} secondary data-testid={'filterButton'} />
                        {/*)}*/}
                    </div>
                )}
            </Form>
        </div>
    )
}

export default memo(IndexFilter)
